import { render } from "./learner.vue?vue&type=template&id=2b4b2fb0&ts=true"
import script from "./learner.vue?vue&type=script&lang=ts"
export * from "./learner.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__